import { ApiObterFuncionarios, ApiObterFuncionariosFiltro } from '@/api'
import { defineStore } from 'pinia'

export const Funcionarios = defineStore('Funcionarios', {
   state: () => ({
      funcionarios: null,
      funcionariosFiltro: null
   }),
   actions: {
      async ActionObterFuncionarios(filtros) {
         await ApiObterFuncionarios(filtros).then((resposta) => (this.funcionarios = resposta))
      },
      async ActionbterFuncionariosFiltro(filtro) {
         await ApiObterFuncionariosFiltro(filtro).then((resposta) => (this.funcionariosFiltro = resposta))
      }
   }
})
